import { Button, Icon } from "@sellar-io/components";
import { useState } from "react";
import { useCartSummary } from "../discovery/v2/distribution/useCartSummary";
import { QuantityIndicator } from "../../components/quantityIndicator/QuantityIndicator";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { DraftBasketDrawer } from "../discovery/v2/distribution/DraftBasketDrawer";
import { useConsolidatedBasketTracking } from "../discovery/v2/distribution/consolidatedOrderingTracking";
import { useCanShowDeliveredBySellarOptionV2 } from "../discovery/v2/lib/useCanShowDeliveredBySellarOptionV2";

export const RetailerCart = ({ className }: { className: string }) => {
  const [active, setActive] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const { trackBasketOpened } = useConsolidatedBasketTracking();
  const canShowDeliveredBySellar = useCanShowDeliveredBySellarOptionV2();
  const sdConsolidatedCheckoutEnabled = useRemoteFeatureFlags().isActive(
    "sdConsolidatedCheckout",
  );
  const showDeliveredBySellarFeatures =
    sdConsolidatedCheckoutEnabled && canShowDeliveredBySellar;
  const { totalItemCount: itemCount, baskets } = useCartSummary({
    showDeliveredBySellarFeatures,
    includeStorefrontDrafts: false,
  });

  return (
    <>
      <Button
        color="transparent"
        aria-label={`Basket, ${itemCount} ${itemCount === 1 ? "item" : "items"}`}
        aria-haspopup="dialog"
        aria-expanded={active}
        className={className}
        onClick={() => {
          if (showDeliveredBySellarFeatures) {
            trackBasketOpened(baskets, "navbar");
          }
          setHasOpened(true);
          setActive(true);
        }}
      >
        <Icon icon="CART_OUTLINE" size="18px" />
        {itemCount > 0 && (
          <QuantityIndicator
            quantity={itemCount}
            className="absolute -top-1 -right-1 h-4 w-auto min-w-4 bg-[#a34fd2] px-0.5 text-xs leading-4 font-semibold"
          />
        )}
      </Button>
      {hasOpened && (
        <DraftBasketDrawer
          appear
          active={active}
          setActive={setActive}
          showDeliveredBySellarFeatures={showDeliveredBySellarFeatures}
          includeStorefrontDrafts={false}
        />
      )}
    </>
  );
};
